






















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import store from "@/store";
import getUrlParam from '@/common/utils/getUrlParam';
import { resolveBoundaryValue } from '@/common/utils/format';

@Component({})
export default class GachaRadio extends Vue {
  @Getter('section') section!: any;
  @Action("changeSectionInfo") changeSectionInfo!: Function;

  get disabled() {
    return getUrlParam('type') === 'reEdit';
  }

  get gachaTypeParameter() {
    return store.getters.gachaTypeParameter;
  }

  toggleDayTimesStatus() {
    if(getUrlParam('type') === 'reEdit' && getUrlParam('broadcastId')){
      return;
    }
    store.dispatch("changeDayTimesStatus");
  }

  toggleTotalTimesStatus() {
    if(getUrlParam('type') === 'reEdit' && getUrlParam('broadcastId')){
      return;
    }
    store.dispatch("changeTotalTimesStatus");
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    const _value = resolveBoundaryValue(value, hasDecimal);
    this.changeSectionInfo({ type, value: _value });
  }
}
